import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { projects } from '../mock';
import ProjectSheet from './ProjectSheet';

function ProjectCard({ project, featured, onOpen }) {
  return (
    <button
      onClick={() => onOpen(project)}
      className={`proj-card text-left group ${featured ? 'md:col-span-2' : ''}`}
    >
      <div className="img-wrap aspect-[16/10] md:aspect-[16/9] bg-navy-3">
        <img
          src={project.cover}
          alt={project.title}
          className="w-full h-full object-cover"
          style={{ objectPosition: 'top center' }}
          loading="lazy"
        />
      </div>
      <div className="p-6 md:p-8">
        <div className="flex items-start justify-between gap-6">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-orange-acc">
              {project.index} — {project.year}
            </p>
            <h4 className="mt-2 font-display text-3xl md:text-5xl text-cream tracking-wide">
              {project.title}
            </h4>
          </div>
          <span className="shrink-0 mt-2 w-11 h-11 rounded-full border border-cream/30 flex items-center justify-center text-cream group-hover:bg-orange-acc group-hover:text-navy group-hover:border-orange-acc transition-colors">
            <ArrowUpRight size={18} />
          </span>
        </div>
        <p className="mt-4 text-cream-soft/80 max-w-2xl text-sm md:text-base leading-relaxed">
          {project.summary}
        </p>
        <div className="mt-5 flex flex-wrap gap-2">
          {project.tags.map((t) => (
            <span
              key={t}
              className="text-[10px] uppercase tracking-[0.22em] px-2.5 py-1 border border-cream/25 text-cream-soft/85"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </button>
  );
}

function WorkHeader() {
  return (
    <>
      <div className="flex items-center gap-4 mb-12">
        <span className="font-display text-orange-acc text-2xl">02</span>
        <span className="text-[11px] uppercase tracking-[0.32em] text-cream-soft/70">Selected Work</span>
        <div className="flex-1 h-px bg-cream/20" />
        <span className="text-[11px] uppercase tracking-[0.32em] text-cream-soft/60">
          {projects.length} projects
        </span>
      </div>
      <h3 className="font-display text-4xl md:text-7xl leading-[1] text-cream max-w-4xl">
        Stories carried by <span className="text-orange-acc">colour</span>, paper &amp; pixels.
      </h3>
      <p className="mt-6 text-cream-soft/80 max-w-xl">
        A cross-section of recent studio, classroom and self-initiated projects across illustration,
        packaging, animation and identity.
      </p>
    </>
  );
}

export default function Work() {
  const [active, setActive] = useState(null);

  return (
    <section id="work" className="relative py-24 md:py-32 border-t border-cream">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <WorkHeader />

        <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
          {projects.map((p, i) => (
            <ProjectCard
              key={p.id}
              project={p}
              featured={i % 3 === 0}
              onOpen={setActive}
            />
          ))}
        </div>
      </div>

      <ProjectSheet project={active} onClose={() => setActive(null)} />
    </section>
  );
}
